module.exports = __webpack_public_path__ + "static/BuenosAiresWeb-SemiBold-cdcaff949fd4c935926eedf7693abe57.woff2";